import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { mixinsClassName, dom } from '../../utils';

export default class extends Component {
    tigger(act) {
        let el = dom(this);
        let toggleEl = el.find(".dropdown-toggle");
        let isOpen = el.is(".open");
        if (act === "hide") {
            isOpen && toggleEl[0].click();
        } else {
            !isOpen && toggleEl[0].click();
        }
    }

    show() {
        this.tigger("show");
    }

    hide() {
        this.tigger("hide");
    }

    render() {
        const { textKey = 'text', data = [], onSelect } = this.props;
        let className = mixinsClassName("ui-menu", this.props);

        return (
          <DropdownButton className={className} noCaret>
            {
              data.map((item)=>{
                return <MenuItem onSelect={onSelect.bind(this, item)}>{item[textKey]}</MenuItem>
              })
            }
          </DropdownButton>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/menu/index.js